import { ConditionalPartial } from '../../../../utils';

import { CreateRecallProcessConfigRequestDto } from './create-recall-process-config.request.dto';

/**
 * DTO for updating recall process configuration
 * All fields are optional for partial updates
 */
export class UpdateRecallProcessConfigRequestDto extends ConditionalPartial(CreateRecallProcessConfigRequestDto) {}
